module.exports = __webpack_public_path__ + "media/images/default/pages/public_sciences/main/1-3cccc8a461d5e83f166a2e98ae061749.svg";